// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3OtjS","row":"Node_row__1w0--","label":"Node_label__1Ozqh","footer":"Node_footer__3QW1_"};